import React from "react";
import HeroImageSection from "../components/HeroImageSection";
import Projects from "../components/Projects";
import { BlurImage } from "../pages/ServicesPage";
import bg_all from "../assets/main_h.png";
import { Helmet } from "react-helmet-async";
const ProjectsPage = () => (
  <>
    <Helmet>
  {/* Primary SEO */}
  <title>
    Solar Projects & EPC Installations | Savorka Solar
  </title>

  <meta
    name="description"
    content="Explore Savorka's portfolio of residential, commercial, and industrial solar projects showcasing expert solar panel installation and turnkey Solar EPC execution."
  />

  <meta
    name="keywords"
    content="solar epc companies, solar panel installation services"
  />

  <meta name="robots" content="index, follow" />

  <link rel="canonical" href="https://www.savorka.in/projects" />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta
    property="og:title"
    content="Solar Projects & EPC Installations | Savorka Solar"
  />
  <meta
    property="og:description"
    content="Explore Savorka's portfolio of residential, commercial, and industrial solar projects showcasing expert solar panel installation and turnkey Solar EPC execution."
  />
  <meta property="og:url" content="https://www.savorka.in/projects" />
  <meta
    property="og:image"
    content="https://www.savorka.in/static/media/savorkalogo.e098837e544b8a11c754.png"
  />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta
    name="twitter:title"
    content="Solar Projects & EPC Installations | Savorka Solar"
  />
  <meta
    name="twitter:description"
    content="Explore Savorka's residential, commercial and industrial solar projects completed across India."
  />
  <meta
    name="twitter:image"
    content="https://www.savorka.in/static/media/savorkalogo.e098837e544b8a11c754.png"
  />
</Helmet>

    <main>
      <HeroImageSection title="OUR PROJECTS" heroImage={bg_all} />
      <Projects />
      <BlurImage />
    </main>
  </>
);

export default ProjectsPage;
